export enum MessageType {
  TEXT = "TEXT",
  CALL = "CALL",
  VOICE = "VOICE",
}
